import PropTypes from 'prop-types';

export const Vendor = {
  id: PropTypes.number,
  userId: PropTypes.string,
  vendorName: PropTypes.string,
  location: PropTypes.string,
  status: PropTypes.string,
  contactPerson: PropTypes.string,
  isActive: PropTypes.bool,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
}; 